import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Cutttingedge(props) {
  return (
    <div className="p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="App">
              <h2>
                Do You Want to Increase the Customer Retention Rate by 75%
                Through Flutter App Solutions?
              </h2>
            </div>
            <p>Collaborate with us to redefine your mobile app presence.</p>

            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Consult with Us Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Cutttingedge;
